'use client';

import React from 'react';
import { useSupabaseData } from '@/hooks/useSupabaseData';

/**
 * This component loads all Supabase data into the store when mounted.
 * It must be inside both AuthProvider and AppProvider.
 */
export default function SupabaseDataLoader({ children }: { children: React.ReactNode }) {
  useSupabaseData();
  return <>{children}</>;
}
